<template>
  <div>
    <div class="EdicaoVinculacoes_header">
      <div class="row">
        <div class="col">
          <label class="label EdicaoVinculacoes_title pl-2">
            <icon-svg icon="simplePencil"
                      class="icon icon--sm icons--white pr-1" />
            Selo vinculador {{ propSeloVinculador.num_selo }} - OS {{ propSeloVinculador.seloItemOs.ordemServicoItem.ordemServico.numero }}
          </label>
        </div>
      </div>
    </div>

    <div v-if="vinculacoes.filter(vinculacao => !!vinculacao.erroVinculacaoTJ).length > 0"
         calss="pt-2">
      <div class="row ErroVinculacaoTJ ml-3 pr-3">
        Erro(s) informado(s) pelo TJSP:
      </div>

      <div v-for="(vinculacao, index) in vinculacoes.filter(vinculacao => !!vinculacao.erroVinculacaoTJ)"
           :key="`erro_vinculacao_${index}`"
           class="row">
        <p class="ErroVinculacaoTJ">
          - {{ vinculacao.erroVinculacaoTJ.replace(/^.+Erro:/, '') }}
        </p>
      </div>
    </div>

    <b-tabs align="left"
            class="mt-4"
            active-nav-item-class="EditarVinculacoes--tab-active">
      <b-tab class="contentSelosVinculados"
             @click="tabIndex=0"
             @keydown.tab.prevent="tabIndex=0">
        <template v-slot:title>
          Selos vinculados
        </template>
      </b-tab>

      <b-tab @click="tabIndex=1"
             @keydown.tab.prevent="tabIndex=1">
        <template v-slot:title>
          Vincular selos
        </template>
      </b-tab>
    </b-tabs>

    <div class="row MarginRegistroAtual">
      <div class="col">
        <label class="EdicaoVinculacoes_subheader pl-3 mb-0">
          Registro atual
        </label>
      </div>
    </div>

    <div v-if="tabIndex === 0">
      <div v-for="(registroId, index) in registrosIds"
           :key="`registro_${index}`">
        <ListagemSelos v-if="registroId === propRegistroId"
                       :prop-selos="vinculacoes.filter(seloVinculado => seloVinculado.registro_id === registroId)"
                       :prop-registro-id="registroId"
                       :prop-read-only="true"
                       @deleteVinculacoes="excluirVinculacoesDisponiveis" />

        <div v-if="registroId !== propRegistroId">
          <div v-for="(registro, index) in [vinculacoes.find(seloVinculado => seloVinculado.registro_id === registroId).registro]"
               :key="`outro_registro_${index}`"
               class="mt-4">
            <HeaderBoxRegistro :prop-registro="registro" />

            <ListagemSelos :prop-selos="vinculacoes.filter(seloVinculado => seloVinculado.registro_id === registroId)"
                           :prop-registro-id="registroId"
                           :prop-read-only="true"
                           @deleteVinculacoes="excluirVinculacoesDisponiveis" />
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="tabIndex === 1">
      <label class="pl-3 pt-3 mb-0">
        Escolha os selos que serão vinculados:
      </label>

      <div v-if="selosPendentesVinculacao.length > 0">
        <ListagemSelos :prop-selos="selosPendentesVinculacao"
                       :prop-registro-id="propRegistroId"
                       :prop-focus-selecionar-todos="true"
                       @selecionados="selosSelecionados" />
      </div>

      <div v-if="registrosSelecionados.length > 0">
        <div v-for="(registro, index) in registrosSelecionados"
             :key="`registro_selecionado_${index}`"
             class="mt-4">
          <HeaderBoxRegistro :prop-registro="registro" />

          <ListagemSelos v-if="registro.selos"
                         :prop-selos="registro.selos"
                         :prop-registro-id="registro.registro_id"
                         :prop-focus-selecionar-todos="true"
                         @selecionados="selosSelecionados" />
        </div>
      </div>

      <button :ref="`modalVinculacaoDemaisSelos_${_uid}`"
              v-b-modal="`modalVinculacaoDemaisSelos_${_uid}`"
              class="btn btn-sm btn-outline-primary btn-add-selo btn-block my-3"
              type="button"
              @click="modalVinculacaoDemaisSelos = true"
              @keyup.enter="modalVinculacaoDemaisSelos = true">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar selos de outro registro
      </button>

      <BuscaSelosOutrosRegistros v-if="modalVinculacaoDemaisSelos"
                                 :prop-registro-id="propRegistroId"
                                 :prop-cpf-registrado="propCpfRegistrado"
                                 :prop-nome-registrado="propNomeRegistrado"
                                 @voltar="modalVinculacaoDemaisSelos = false"
                                 @registroSelecionado="registroSelecionado" />
    </div>

    <div class="mt-4 mb-2 border-top border-primary pt-3">
      <div class="row col-12 pl-0 ml-0 pr-0 mr-0">
        <div class="col-3 pl-0">
          <button class="btn btn-sm btn-danger btn-trash-vinculacoes pl-3 pr-3"
                  :disabled="!(vinculacoes.filter(vinculacao => !!vinculacao.erroVinculacaoTJ || !vinculacao.envio_vinculacao_tj).length > 0)"
                  @click="excluirVinculacoesDisponiveis()">
            <IconSvg class="icon-trash icon--sm mr-1"
                     icon="trash" />
            Excluir todas as vinculações
          </button>
        </div>

        <div class="col-6" />

        <div class="col-3 pl-5 pr-0">
          <div :class="{ 'd-inline-block ml-5 pl-4': tabIndex === 1 }">
            <button class="btn btn-sm btn-dark ml-3 pl-3 pr-3"
                    :class="{ 'float-right' : tabIndex === 0 }"
                    @click="$emit('voltarParaTelaInicial')">
              Voltar
            </button>
          </div>

          <div v-if="tabIndex === 1"
               class="d-inline-block ml-2 pl-1">
            <button class="btn btn-sm btn-primary pl-3 pr-3"
                    :disabled="!(vinculacoesParaAdicionar.length > 0)"
                    @click="salvar()">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-if="modalExcluirVinculacoes"
             :id="`excluirVinculacoes_${_uid}`"
             modal-class="FimEdicaoVinculacoes"
             body-class="FimEdicaoVinculacoes_body"
             header-class="FimEdicaoVinculacoes_header"
             :visible="true"
             hide-header
             hide-footer
             centered
             size="md"
             @hide="cancelarExclusao()">
      <div class="FimEdicaoVinculacoes_titulo mt-1"
           :class="excluirTodas ? 'ml-4 mr-4' : 'FimEdicaoVinculacoes_text_align_center'">
        Confirma a exclusão da vinculação{{ excluirTodas ? 'de todos os selos não aprovados pelo TJ' : '' }}?
      </div>

      <div class="row no-gutters justify-content-center align-items-center">
        <div class="d-inline-block mt-3 mb-1 ml-3">
          <button ref="nao_excluir_vinculacoes"
                  class="btn btn-sm FimEdicaoVinculacoes_botao-cancelar pl-4 pr-4"
                  type="button"
                  @click="cancelarExclusao()">
            Não
          </button>
        </div>

        <div class="d-inline-block ml-4 mt-3 mb-1 mr-3">
          <button class="btn btn-sm btn-primary pl-4 pr-4"
                  type="button"
                  @click="excluirTodas ? excluirTodasAsVinculacoes() : deleteVinculacoes([excluirVinculacaoSeloId])">
            Sim
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="modalSalvarAlteracoes"
             :id="`salvarVinculacoes_${_uid}`"
             modal-class="FimEdicaoVinculacoes"
             body-class="FimEdicaoVinculacoes_body"
             header-class="FimEdicaoVinculacoes_header"
             :visible="true"
             hide-header
             hide-footer
             centered
             size="md"
             @hide="modalSalvarAlteracoes = false">
      <div class="FimEdicaoVinculacoes_titulo mt-1 ml-4">
        Gostaria de enviar ao TJ a alteração da lista de selos vinculados?
      </div>

      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block mt-3 mb-1">
          <button ref="salvar_vinculacao_deixar_para_depois"
                  class="btn btn-sm FimEdicaoVinculacoes_botao-voltar pl-4 pr-4"
                  @click="salvarVinculacoes()">
            Deixar para mais tarde
          </button>
        </div>

        <div class="d-inline-block ml-2 mt-3 mb-1 mr-3">
          <button class="btn btn-sm btn-primary pl-4 pr-4"
                  @click="salvarVinculacoes(true)">
            Enviar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import moment from 'moment'

  /* services */
  import SelosService from "@/services/Registros/SelosService"

  /* components */
  import ListagemSelos from '@/components/SofiaRei/Resumo/Selo/ListagemSelos'
  import HeaderBoxRegistro from '@/components/SofiaRei/Resumo/HeaderBoxRegistro'
  import BuscaSelosOutrosRegistros from '@/components/SofiaRei/Resumo/Selo/BuscaSelosOutrosRegistros'

  export default {
    name: 'EdicaoVinculacoes',
    components: {
      ListagemSelos,
      HeaderBoxRegistro,
      BuscaSelosOutrosRegistros
    },
    props: {
      propRegistroId: { type: Number, default: () => null },
      propCpfRegistrado: { type: String, default: () => null },
      propNomeRegistrado: { type: String, default: () => null },
      propDataVinculacao: { type: String, default: () => null },
      propSeloVinculador: { type: Object, default: () => ({}) }
    },
    data () {
      return {
        // Controle de mudança de tab
        tabIndex: 0,

        // Selo vinculador retornado na pesquisa detalhada
        seloVinculador: null,

        // As vinculações do selo vinculador, formatadas para esse vue
        vinculacoes: [],

        // Lista de registros Ids diferentes nas vinculações        
        registrosIds: [],

        // Lista de selos para adicionar na vinculação
        vinculacoesParaAdicionar: [],

        // Registro selecionado pela busca
        registrosSelecionados: [],
        
        // Controle do modal de busca de outros registros
        modalVinculacaoDemaisSelos: false,

        // Lista de selos desse registro
        selosPendentesVinculacao: [],

        // Controle para excluir todas as vinculações
        modalExcluirVinculacoes: false,
        excluirTodas: false,
        excluirVinculacaoSeloId: null,

        // Controle para modal de salvar alterações
        modalSalvarAlteracoes: false
      }
    },
    async beforeMount () {
      await this.getSeloDetalhado()
      await this.getSelosPendentesVinculacao()

      const tabSelosVinculados = document.querySelector('.EditarVinculacoes--tab-active')

      setTimeout(() => {
        if (tabSelosVinculados) {
          tabSelosVinculados.focus()
        }
      }, 100)
    },
    methods: {
      async getSeloDetalhado () {
        if (!this.propSeloVinculador || !this.propDataVinculacao) {
          this.seloVinculador = null
          return
        }

        loader({ text: 'Buscando selo vinculador...', active: true })

        const params = {
          numSeloVinculador: this.propSeloVinculador.num_selo,
          dataVinculacao: moment(this.propDataVinculacao).format('YYYY-MM-DD HH:mm:ss')
        }

        try {
          this.seloVinculador = await SelosService.getSeloVinculadorDetalhado(params)

          this.vinculacoes = this.seloVinculador.vinculacoes.map(vinculacao => {
            // Deixamos o id da vinculação
            vinculacao.seloVinculacao.vinculacao_selo_id = vinculacao.vinculacao_selo_id

            // Erro vinculação TJ
            vinculacao.seloVinculacao.erroVinculacaoTJ = vinculacao.erro_vinculacao_tj
            
            // Vinculação enviada pro TJ
            vinculacao.seloVinculacao.envio_vinculacao_tj = vinculacao.envio_vinculacao_tj

            // Variáveis para listagem dos selos
            vinculacao.seloVinculacao.disableCheckbox = !!vinculacao.envio_vinculacao_tj
            vinculacao.seloVinculacao.check = !!vinculacao.envio_vinculacao_tj

            // Formatamos as datas
            vinculacao.seloVinculacao.dataVinculacaoFormatada = moment(vinculacao.data_vinculacao).format('DD/MM/YYYY - HH:mm')
            vinculacao.seloVinculacao.dataVinculacaoFormatada = vinculacao.seloVinculacao.dataVinculacaoFormatada.replace(':', 'h')

            return vinculacao.seloVinculacao
          })

          // Ordermos pelo registro_id
          this.vinculacoes.sort((a, b) => { a.registro_id - b.registro_id })

          // Separamos os registros ids
          this.vinculacoes.forEach((seloVinculado, index) => {
            if (index === 0) {
              this.registrosIds.push(seloVinculado.registro_id)
              return
            }

            const ultimoIndexRegistroId = this.registrosIds.length - 1

            if (seloVinculado.registro_id !== this.registrosIds[ultimoIndexRegistroId]) {
              this.registrosIds.push(seloVinculado.registro_id)
            }
          })

          // Pegamos o index do mesmo registro id da prop, caso exista no array, colocamos ele no index 0, para mostrar ele primeiro.
          const indexRegistroId = this.registrosIds.indexOf(this.propRegistroId)
          
          if (indexRegistroId >= 0) {
            this.registrosIds.splice(indexRegistroId, 1)

            this.registrosIds = [this.propRegistroId, ...this.registrosIds]
          }

          // Retiramos os ids duplicados
          this.registrosIds = [...new Map(this.registrosIds.map(item => [item, item])).values()]
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar o selo vinculador'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },

      async getSelosPendentesVinculacao () {
        if (!this.propRegistroId) {
          this.selosPendentesVinculacao = []
          return
        }

        loader({ text: 'Buscando pendentes de vinculação...', active: true })

        const params = {
          registro_id: this.propRegistroId,
          num_selo_vinculador: this.propSeloVinculador.num_selo
        }

        try {
          this.selosPendentesVinculacao = await SelosService.getSelosRegistro(params)

          // Atualizamos o controle de selos selecionados
          this.selosPendentesVinculacao.forEach(selo => {
            const mesmaVinculacao = this.vinculacoes.find(vinculacao => vinculacao.num_selo === selo.num_selo)

            selo.disableCheckbox = (!!mesmaVinculacao || !!selo.vinculador || selo.vinculacoes.length > 0)
            selo.check = !!mesmaVinculacao
          })

          if (this.selosPendentesVinculacao.length > 0) {
            setTimeout(() => {
              if (this.$refs[`modalVinculacaoDemaisSelos_${this._uid}`]) {
                this.$refs[`modalVinculacaoDemaisSelos_${this._uid}`].focus()
              }
            }, 100)
          }
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar os selos desse registro que ainda não foram vinculados'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },

      selosSelecionados ({ registroId, selos }) {
        const indexSelecionado = this.vinculacoesParaAdicionar.findIndex(selecionado => selecionado.registroId === registroId)

        if (indexSelecionado < 0) {
          this.vinculacoesParaAdicionar.push({
            registroId,
            selos
          })

          return
        }

        if (selos.length === 0) {
          this.vinculacoesParaAdicionar.splice(indexSelecionado, 1)
          return
        }

        this.vinculacoesParaAdicionar[indexSelecionado].selos = selos
      },

      excluirVinculacoesDisponiveis (vinculacaoSeloId = null) {
        this.modalExcluirVinculacoes = true

        if (vinculacaoSeloId) {
          this.excluirVinculacaoSeloId = vinculacaoSeloId
        } else {
          this.excluirTodas = true
        }

        setTimeout(() => {
          if (this.$refs['nao_excluir_vinculacoes']) {
            this.$refs['nao_excluir_vinculacoes'].focus()
          }
        }, 100)
      },

      cancelarExclusao () {
        this.modalExcluirVinculacoes = false
        this.excluirTodas = false
        this.excluirVinculacaoSeloId = null
      },

      salvar () {
        this.modalSalvarAlteracoes = true

        setTimeout(() => {
          if (this.$refs['salvar_vinculacao_deixar_para_depois']) {
            this.$refs['salvar_vinculacao_deixar_para_depois'].focus()
          }
        }, 100)
      },

      registroSelecionado (registro) {
        const indexSelecionadoRegistro = this.registrosSelecionados.findIndex(reg => reg.registro_id === registro.registro_id)

        if (indexSelecionadoRegistro >= 0) {
          objSwal.info.title = ''
          objSwal.info.text = 'Esse registro escolhido já foi selecionado'
          objSwal.info.html = ''

          return Swal.fire(objSwal.info)
        }

        // Atualizamos o controle de selos selecionados
        registro.selos.forEach(selo => {
          const mesmaVinculacao = this.vinculacoes.find(vinculacao => vinculacao.num_selo === selo.num_selo)
          
          selo.disableCheckbox = (!!mesmaVinculacao || !!selo.vinculador || selo.vinculacoes.length > 0)
          selo.check = !!mesmaVinculacao
        })

        this.registrosSelecionados.push(registro)
        this.modalVinculacaoDemaisSelos = false
      },

      // Excluimos somente as vinculações que não foram enviadas ao TJ ou tiveram algum erro no envio. Enquanto não temos a desvinculação.
      excluirTodasAsVinculacoes () {
        const vinculacoesParaExcluirTodos = this.vinculacoes.filter(vinculacao => !!vinculacao.erroVinculacaoTJ || !vinculacao.envio_vinculacao_tj)

        const vinculacoesIds = vinculacoesParaExcluirTodos.map(vinculacao => vinculacao.vinculacao_selo_id)

        if (!vinculacoesIds || !vinculacoesIds.length) {
          objSwal.info.title = ''
          objSwal.info.text = 'Não tem vinculações selecionadas para excluir'
          objSwal.info.html = ''

          return Swal.fire(objSwal.info)
        }

        return this.deleteVinculacoes(vinculacoesIds)
      }, 

      async deleteVinculacoes (vinculacoesIds = []) {
        if (!vinculacoesIds.length) return

        loader({ text: 'Aguarde...', active: true })

        try {
          await SelosService.excluirVinculacoes({ vinculacoesIds })

          this.$root.$emit('bv::hide::modal', `excluirVinculacoes_${this._uid}`)
          
          loader({ text: '', active: false })

          objSwal.info.title = ''
          objSwal.info.text = 'Exclusão realizada com sucesso!'
          objSwal.info.html = ''

          await Swal.fire(objSwal.info).then(() => {
            this.$emit('voltarParaTelaInicial')
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        } catch (e) {
          loader({ text: '', active: false })

          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível realizar a exclusão'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      },

      async salvarVinculacoes (enviarTJ = false) {
        try {
          loader({ text: 'Aguarde...', active: true })

          const numSelos = []

          this.vinculacoesParaAdicionar.forEach(selecionado => {
            selecionado.selos.forEach(selo => numSelos.push(selo.num_selo))
          })

          let seloVinculador = null

          if (numSelos.length) {
            const data = {
              numSeloVinculador: this.propSeloVinculador.num_selo,
              vinculacoes: numSelos,
              realizarEnvioVinculacaoTJ: enviarTJ,
              dataVinculacao: moment(this.propDataVinculacao).format('YYYY-MM-DD HH:mm:ss')
            }

            seloVinculador = await SelosService.vincularSelos(data)
          }

          this.$root.$emit('bv::hide::modal', `salvarVinculacoes_${this._uid}`)

          loader({ text: '', active: false })

          let texto = 'Alteração salva com sucesso!'

          if (seloVinculador) {
            const vinculacoesComErro = seloVinculador.vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)
  
            if (vinculacoesComErro.length) {
              texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
              texto += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
            }
          }

          objSwal.info.title = ''
          objSwal.info.text = texto
          objSwal.info.html = ''

          await Swal.fire(objSwal.info).then(() => this.$emit('voltarParaTelaInicial'))

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        } catch (e) {
          loader({ text: '', active: false })

          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível salvar a alteração'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .ErroVinculacaoTJ {
    width: 100%;
    color: #8b0000;
    margin: 15px 20px 0px 30px;
    font-size: 20px;
    font-weight: 500;
  }

  .EdicaoVinculacoes {
    &_header {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: $sinoreg-blue;
      color: $color-white;
      line-height: 35px;
    }

    &_title {
      font-size: pxToRem(17) !important;
      font-weight: 500;
    }

    &_subheader {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: #f0ecec;
      line-height: 35px;
      width: 100%;
    }
  }

  .MarginRegistroAtual {
    margin-top: -5px;
  }
  .OutrosRegistros {
    &--header {
      background-color: $sofiaRei-blue;
      min-height: 30px;
      display: flex;
      align-content: center;
      width: 100%;
    }

    &--tipo {
      font-size: 1rem;
    }

    &--table-width {
      flex: 0 0 28%;
      max-width: 28%;
    }

    &--table {
      font-size: 12px;
      & tr:first-child {
        border-bottom: 1px solid black;
      }

      & th, td {
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    &--cartorio {
      font-size: 14px;
    }

    &_titulo_nascimento_casamento {
      flex: 0 0 10%;
      max-width: 10%;
    }

    &_titulo_cas_reg {
      flex: 0 0 16%;
      max-width: 16%;
    }

    &_titulo_hab {
      flex: 0 0 19%;
      max-width: 19%;
    }

    &_titulo_obito {
      flex: 0 0 6%;
      max-width: 6%;
    }
  }

  /deep/ .nav-tabs .nav-link.active {
    background-color: #f0ecec;
    border: 0px !important;
  }

  /deep/ ul.nav > li.nav-item > a.nav-link:focus {
    outline: 2px solid black;
  }
  
  .btn-add-selo:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

  .btn-trash-vinculacoes > [class*=icon-trash] {
    fill: #fff !important;
  }

  .icon-trash {
    fill: #8B0000 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

  .FimEdicaoVinculacoes {
    &_titulo {
      font-size: 17.5px;
    }

    &_text_align_center {
      text-align: center;
    }

    &_botao-voltar {
      background-color: #c8c4c4;
    }

    &_botao-cancelar {
      color: white;
      background-color: #8B0000;
    }
  }
</style>
